import StoreModule from "@/utils/StoreModule";

const hrWorkTimes = StoreModule("/hr/attendance/hr-work-times");

export default hrWorkTimes;
